
import { SignersForm } from "./Signatories";
import { SubjectForm } from "./Subject";
//import { GeneralForm } from "./general-form/GeneralForm";
import { FieldsForm } from "./Fields";
import { TYPES } from "../../../../../config/constants/typesReducers";
import { SubmissionProgressForm } from "./Review";
const {DRAFT} = TYPES;

//Se declaran los apartados con su formato, debido a que cada formulario es distinto se opta por declarar un componente diferente
const forms = [
    //{
    //  title: 'General',
    //  caption: 'Configure general settings for the document',
    //  type: '',
    //  CustomForm: GeneralForm,
    //},
    {
      title: 'Agregar Firmantes',
      caption: 'Agrega las personas que firmarán el documento.',
      type: DRAFT.SIGNERS,
      CustomForm: SignersForm,
    },
    {
      title: 'Agregar Campos',
      caption: 'Agrega todos los campos relevantes para cada destinatario.',
      type: '',
      CustomForm: FieldsForm,
    },
    {
      title: 'Asunto del correo',
      caption: 'Define el asunto y el mensaje que deseas enviar a los firmantes.',
      type: DRAFT.SUBJECT,
      CustomForm: SubjectForm,
    },
    {
      title: 'Revisar',
      caption: 'Revisa el documento antes de enviarlo.',
      type: '',
      CustomForm: SubmissionProgressForm
    }
];

export default forms